export const TOKEN_STORAGE_USER_KEY = 'ls_managed_analytics_token'

export const VISUAL_TOKEN_STORAGE_KEY = 'ls_managed_analytics_visual_token'

export const LOGIN_STORAGE_USER = 'ls_managed_analytics_user'

export const CODE_VERIFIER_STORAGE_KEY = 'ls_managed_analytics_code_verifier'

export const REDIRECT_TO_STORAGE_KEY = 'ls_managed_analytics_redirect_to'

// The logged-in user, as stored under LOGIN_STORAGE_USER
export type StoredUser = {
  email: string
  first_name: string
  last_name: string
  client: string
  issuer: string
  org_id?: string
}
